/**
 * Authentication configuration
 * Centralized configuration for auth-related settings
 */

export const AUTH_CONFIG = {
  // Token settings
  ACCESS_TOKEN_EXPIRY: 60 * 60, // 1 hour in seconds
  REFRESH_TOKEN_EXPIRY: 60 * 60 * 24 * 7, // 7 days in seconds

  // Cookie settings (backend-controlled HttpOnly auth cookies)
  COOKIE_SETTINGS: {
    SECURE: true, // Only send over HTTPS
    SAME_SITE: 'strict', // Protect against CSRF
    PATH: '/',
    DOMAIN: process.env.REACT_APP_COOKIE_DOMAIN || undefined,
  },

  // Storage settings
  STORAGE_TYPE: 'cookies', // 'localStorage', 'sessionStorage', 'cookies', 'memory'

  // Token refresh settings
  REFRESH_THRESHOLD: 5 * 60, // Refresh token 5 minutes before expiry
  REFRESH_RETRY_ATTEMPTS: 3,
  REFRESH_RETRY_DELAY: 1000, // 1 second

  // Security settings
  AUTO_LOGOUT_ON_EXPIRY: true,
  CHECK_TOKEN_ON_VISIBILITY_CHANGE: true,
  CHECK_TOKEN_ON_STORAGE_CHANGE: true,
  PERIODIC_TOKEN_CHECK: 5 * 60 * 1000, // Check every 5 minutes

  // API endpoints
  ENDPOINTS: {
    LOGIN: '/api/Auth/LoginBackOffice',
    REFRESH: '/api/Auth/RefreshToken',
    LOGOUT: '/api/Auth/Logout',
    VALIDATE: '/api/Auth/ValidateToken',
  },

  // Error handling
  ERROR_CODES: {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    TOKEN_EXPIRED: 401,
    INVALID_TOKEN: 401,
  },

  // Redirect settings
  REDIRECTS: {
    LOGIN: '/user/login',
    DASHBOARD: '/dashboard',
    UNAUTHORIZED: '/unauthorized',
    SESSION_EXPIRED: '/user/login?expired=true',
  },

  // Feature flags
  FEATURES: {
    TOKEN_REFRESH: true,
    HTTP_ONLY_COOKIES: true,
    ROLE_BASED_ACCESS: false, // Set to true when implementing RBAC
    MULTI_TAB_SYNC: true,
    REMEMBER_ME: true,
  },
};

// Environment-specific overrides
if (process.env.NODE_ENV === 'development') {
  AUTH_CONFIG.COOKIE_SETTINGS.SECURE = false; // Allow HTTP in development
  AUTH_CONFIG.FEATURES.HTTP_ONLY_COOKIES = true;
}

if (process.env.NODE_ENV === 'production') {
  AUTH_CONFIG.COOKIE_SETTINGS.SECURE = true; // Require HTTPS in production
  AUTH_CONFIG.FEATURES.HTTP_ONLY_COOKIES = true; // Enable httpOnly in production
}

export default AUTH_CONFIG;
